const loadingReducer = (state = false, action) => {
  switch (action.type) {
    case "SET_LOADING":
      return true;
    case "NOT_LOADING":
      return false;
    default:
      return state;
  }
};

export default loadingReducer;
